import PMBPagination from 'components/PMBPagination'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { useEffect, useState } from 'react'
import { Calendar, ChevronDown, Edit2, MapPin } from 'react-feather'
import { Col } from 'reactstrap'
import { TableComponent } from 'components/TableComponent'
import { useDispatch, useSelector } from 'react-redux'
import { useDebounce } from 'helpers'
import { useNavigate } from 'react-router-dom'
import {
  URL_ATTENDANCE_INDIVIDUAL,
  URL_DETAIL_PRODUCTION_UNIT,
  URL_FORM_PRODUCTION_UNIT,
} from 'utils/pathUrl'
import LihatDetail from 'components/Icons/LihatDetail'
import { setFetchOption, toggleModal } from './productionUnitSlice'
import {
  useFetchProductionUnitQuery,
  useFetchProductionUnitSelfQuery,
} from './productionUnitApiSlice'
import { useFetchSharedLandPlotsQuery } from 'features/private-views/farmers-web/shared-farmers/sharedFarmersApiSlice'
import { useIntl } from 'react-intl'
import PMBTooltip from 'components/PMBTooltip'
import moment from 'moment-timezone'
import {
  BUSINESS_MEMBER_PRODUCTION_UNIT,
  BUSINESS_PRODUCTION_UNIT,
  MANAGE,
} from 'utils/subjectActions'
import { Can } from 'context/Acl'
import CustomButton from 'components/Buttons/CustomButton'
import ModalLandPlot from 'features/private-views/farmers-web/detail/ModalLandPlot'

const TableProductionUnit = ({ noSearch, data, userId, isMember, resourceId }) => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const navigate = useNavigate()
  const userId2 = window.location.href.substring(
    window.location.href.lastIndexOf('/') + 1,
  ).split('?')[0]
  const { loading, tag, isOpenModal } = useSelector((s) => s.productionUnit)
  const [searchInput, setSearchInput] = useState('')
  const [selectedRow, setSelectedRow] = useState(null)

  const res = useFetchProductionUnitQuery(
    {
      ...tag,
      userId: userId ?? userId2,
    },
    { skip: !tag || !isMember || Boolean(resourceId) },
  )

  useEffect(() => {
    const value = tag?.s ?? ''
    if (String(searchInput) !== String(value)) setSearchInput(value)
  }, [tag?.s])

  const res2 = useFetchProductionUnitSelfQuery(
    {
      ...tag,
      userId: userId,
    },
    { skip: !tag || isMember || Boolean(resourceId) },
  )

  const resShared = useFetchSharedLandPlotsQuery(
    {
      resourceId,
      userId: userId ?? userId2,
      page: tag?.page ?? 0,
      size: tag?.size ?? 10,
      search: tag?.s,
    },
    {
      skip: !resourceId,
      refetchOnMountOrArgChange: false,
    },
  )

  const activeRes = resourceId ? resShared : isMember ? res : res2
  const tableData = resourceId
    ? resShared?.data?.data?.items || resShared?.data?.items || []
    : isMember
      ? res?.data?.data?.items
      : res2?.data?.data?.items
  const totalItems = resourceId
    ? resShared?.data?.data?.totalItems ?? resShared?.data?.totalItems ?? 0
    : (isMember ? res?.data?.data?.totalItems : res2?.data?.data?.totalItems) || 0

  const columns = [
    {
      name: <span>Tanggal</span>,
      minWidth: '150px',
      sortable: true,
      sortField: 'createdAt',
      cell: (row) => (
        <span data-testid={`production-unit-table-row-${row?.id}`}>
          <div className="d-flex flex-column">
            <span>
              {' '}
              {moment(
                row?.createdAt ?? row?.endRecordTime ?? row?.startRecordTime,
                'DD-MM-YYYY HH:mm',
              )
                .locale('id')
                .format('Do MMM YYYY')}
            </span>
            <span className="text-muted">
              {moment(
                row?.createdAt ?? row?.endRecordTime ?? row?.startRecordTime,
                'DD-MM-YYYY HH:mm',
              )
                .locale('id')
                .format('HH:mm')}
            </span>
          </div>
        </span>
      ),
    },
    {
      name: <span>Kode Wilayah</span>,
      minWidth: '150px',
      sortable: true,
      sortField: 'label',
      cell: (row) => <span>{row?.label ?? '-'}</span>,
    },
    {
      name: <span>Nama</span>,
      minWidth: '150px',
      sortable: true,
      sortField: 'landName',
      cell: (row) => <span>{row?.landName}</span>,
    },

    {
      name: <span>Lokasi</span>,
      sortable: true,
      minWidth: '150px',
      sortField: 'location',
      cell: (row) => {
        return (
          <div className="d-flex flex-column flex-wrap gap-1">
            <span>{row?.location}</span>
            <div
              data-testid={`production-unit-modal-detail-${row?.id}`}
              onClick={() => {
                setSelectedRow(row)
                dispatch(toggleModal())
              }}
              className="d-flex align-items-center gap-1 pointer breadcrumb-hover"
            >
              <MapPin className="text-primary" size={12} />
              <span className="text-primary">Lihat Wilayah</span>
            </div>
          </div>
        )
      },
    },
    {
      name: <span>Luas</span>,
      minWidth: '150px',
      sortable: true,
      sortField: 'size',
      cell: (row) => {
        const size = Number(row?.size) ?? 0

        if (size === 0) {
          return <span>0 Ha (0 km²)</span>
        }

        const ha = size / 10000
        const km2 = size / 1000000

        const km2Formatted = intl.formatNumber(km2, {
          useGrouping: 'always',
          minimumFractionDigits: km2 < 1 ? 4 : 2,
          maximumFractionDigits: km2 < 1 ? 4 : 2,
        })

        return (
          <span>
            {`${intl.formatNumber(ha, {
              useGrouping: 'always',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })} Ha (${km2Formatted} km²)`}
          </span>
        )
      },
    },
    {
      name: <span>Barang</span>,
      minWidth: '150px',
      sortable: true,
      sortField: 'landplottingitem',
      cell: (row) => {
        if (row?.landplottingitem?.length > 0) {
          return (
            <div className="d-flex flex-column py-2">
              <span className="flex-row">
                {row?.landplottingitem?.[0]?.nameItem}
              </span>
              <span className="text-primary">
                {row?.landplottingitem?.[0]?.amount
                  ? intl.formatNumber(row?.landplottingitem?.[0]?.amount, {
                      useGrouping: 'always',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    })
                  : '-'}{' '}
                {row?.landplottingitem?.[0]?.unit}
              </span>
              {row?.landplottingitem.length > 1 ? (
                <div className="bg-gray-100 badge rounded-pill my-1">
                  <span className="text-dark fw-medium">
                    +{' '}
                    {intl.formatNumber(row?.landplottingitem.length - 1, {
                      useGrouping: 'always',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}{' '}
                    barang lainnya
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          )
        } else {
          return '-'
        }
      },
    },
    {
      name: '',
      minWidth: '80px',
      cell: (row) => (
        <div className="d-flex gap-3 align-items-center">
          <div data-testid={`production-unit-detail-button-${row?.id}`}>
            <LihatDetail
              onClick={() => {
                navigate(`${URL_DETAIL_PRODUCTION_UNIT}`, {
                  state: {
                    data: { ...row, ...data },
                    isMember: isMember,
                  },
                })
              }}
              id={row?.id}
            />
          </div>
          {!resourceId && (
            <Can
              I={MANAGE}
              this={
                isMember
                  ? BUSINESS_MEMBER_PRODUCTION_UNIT
                  : BUSINESS_PRODUCTION_UNIT
              }
            >
              <div>
                <div id={`edit-${row?.id}`}>
                  <Edit2
                    size={18}
                    data-testid={`production-unit-edit-button-${row?.id}`}
                    onClick={() => {
                      navigate(`${URL_FORM_PRODUCTION_UNIT}`, {
                        state: {
                          data: { ...row, ...data },
                          isMember: isMember,
                          isEdit: true,
                        },
                      })
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <PMBTooltip target={`edit-${row?.id}`} text="Ubah" />
              </div>
            </Can>
          )}
        </div>
      ),
    },
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction.toUpperCase(),
      }),
    )
  }

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        s: value,
      }),
    )
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && tag?.s.length === 0) {
      e.preventDefault()
    }
  }

  return (
    <>
      <ModalLandPlot
        row={selectedRow}
        isOpen={isOpenModal}
        toggle={() => dispatch(toggleModal())}
        isProductionUnit
      />
      <TableComponent
        columns={columns}
        data={tableData}
        progressPending={
          Boolean(
            activeRes?.isLoading ||
              activeRes?.isFetching ||
              activeRes?.status === 'pending' ||
              loading,
          )
        }
        sortServer
        defaultSortFieldId={1}
        defaultSortAsc={false}
        sortIcon={<ChevronDown />}
        onSort={handleSort}
        pagination
        paginationServer
        paginationComponent={(props) => (
          <PMBPagination
            rowCount={totalItems}
            currentPage={tag?.page}
            rowsPerPage={tag?.size}
            setCurrentPage={(e) => {
              dispatch(setFetchOption({ page: e }))
            }}
            setRowsPerPage={(e) => {
              dispatch(setFetchOption({ size: e }))
            }}
          />
        )}
        subHeader={true}
        subHeaderComponent={
          <div className="w-100 d-flex flex-wrap flex-md-row flex-column align-items-end justify-content-end">
            {/* Cari */}
            {/* {!noSearch && (
              <div className="mb-3 me-md-3" style={{ maxWidth: '300px' }}>
                <PMBSearchInputGroup
                  label={'Cari'}
                  value={searchInput}
                  placeholder="Cari..."
                  onChange={(e) => onHandleSearchChange(e.target.value)}
                  maxWidth="100%"
                  onKeyDown={handleKeyDown}
                />
              </div>
            )} */}

            {!resourceId && (
              <div className="mb-3 d-flex justify-content-end">
                <Can
                  I={MANAGE}
                  this={
                    isMember
                      ? BUSINESS_MEMBER_PRODUCTION_UNIT
                      : BUSINESS_PRODUCTION_UNIT
                  }
                >
                  <CustomButton
                    testId="production-unit-add-button"
                    onClick={() => {
                      navigate(`${URL_FORM_PRODUCTION_UNIT}`, {
                        state: {
                          data: { ...data },
                          isMember: isMember,
                        },
                      })
                    }}
                    color="primary"
                  >
                    Tambah Unit Produksi
                  </CustomButton>
                </Can>
              </div>
            )}
          </div>
        }
      />
    </>
  )
}

export default TableProductionUnit
